import BaseRequest from '@/qingyu/request/base'
import { config } from '@/qingyu'

/**
 * 园区相关API请求类
 */
export default class ParkRequest extends BaseRequest {
/**
 * 获取园区列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回园区列表数据
 */
  getParkList(params) {
    return this.post(config.api.ENTERPRISE.PARK_LIST, params);
}

/**
 * 获取园区详情
 * @param {string} id - 园区ID
 * @returns {Promise} 返回园区详情数据
 */
  getParkDetail(id) {
    return this.post(config.api.ENTERPRISE.PARK_DETAIL, { yuanqu_id: id });
}

/**
 * 获取申请配置
 * @returns {Promise} 返回申请配置数据（空间类型、空间面积等）
 */
  getApplyConfig() {
    return this.post(config.api.ENTERPRISE.APPLY_CONFIG, {});
  }

/**
 * 申请入驻园区
 * @param {Object} data - 申请数据
 * @returns {Promise} 返回申请结果
 */
  applyForPark(data) {
    return this.post(config.api.ENTERPRISE.PARK_APPLY, data);
}

/**
 * 获取园区3D模型数据
 * @param {string} id - 园区ID
 * @returns {Promise} 返回园区3D模型数据
 */
  getPark3DModel(id) {
    return this.get(`/api/park/3d-model/${id}`);
}

/**
   * 获取楼宇列表
   * @param {string} parkId - 园区ID
   * @returns {Promise} 返回楼宇列表
 */
  getBuildingList(parkId) {
    return this.post(config.api.ENTERPRISE.BUILDING_LIST, { yuanqu_id: parkId });
  }

  /**
   * 获取楼层列表
   * @param {string} buildingId - 楼宇ID
   * @returns {Promise} 返回楼层列表
   */
  getFloorList(buildingId) {
    return this.post(config.api.ENTERPRISE.FLOOR_LIST, { building_id: buildingId });
  }

  /**
   * 获取房间列表
   * @param {string} floorId - 楼层ID
   * @returns {Promise} 返回房间列表
   */
  getRoomList(floorId) {
    return this.post(config.api.ENTERPRISE.ROOM_LIST, { floor_id: floorId });
  }


  /**
   * 获取合同信息
   * @returns {Promise} 返回合同信息
   */
  getContractInfo() {
    return this.get('/api/park/contract');
  }

  /**
   * 获取物业费用信息
   * @returns {Promise} 返回物业费用信息
   */
  getPropertyFeeInfo() {
    return this.get('/api/park/property-fee');
  }
  
  /**
   * 获取科技服务列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回科技服务列表
   */
  getKejiServiceList(params) {
    return this.post(config.api.ENTERPRISE.GET_KEJI_SERVICE_LIST, params);
  }
  
  /**
   * 获取金融服务列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回金融服务列表
   */
  getJinrongServiceList(params) {
    return this.post(config.api.ENTERPRISE.GET_JINRONG_SERVICE_LIST, params);
  }
  
  /**
   * 获取生产服务列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回生产服务列表
   */
  getShengchanServiceList(params) {
    return this.post(config.api.ENTERPRISE.GET_SHENGCHAN_SERVICE_LIST, params);
  }
  
  /**
   * 添加科技服务
   * @param {Object} data - 服务数据
   * @returns {Promise} 返回添加结果
   */
  addKejiService(data) {
    return this.post(config.api.ENTERPRISE.ADD_KEJI_SERVICE, data);
  }
  
  /**
   * 添加金融服务
   * @param {Object} data - 服务数据
   * @returns {Promise} 返回添加结果
   */
  addJinrongService(data) {
    return this.post(config.api.ENTERPRISE.ADD_JINRONG_SERVICE, data);
  }
  
  /**
   * 添加生产服务
   * @param {Object} data - 服务数据
   * @returns {Promise} 返回添加结果
   */
  addShengchanService(data) {
    return this.post(config.api.ENTERPRISE.ADD_SHENGCHAN_SERVICE, data);
  }
  
  /**
   * 获取入驻信息列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回入驻信息列表
   */
  getTenancyList(params) {
    return this.post(config.api.ENTERPRISE.TENANCY_LIST, params);
  }
} 